<script>
  import { fade } from 'svelte/transition';
  import { onMount } from 'svelte';

  let width = 100;
  let height = 50;
  $: multiplier = width > height ? 1 : 0.8;
  let ready = false;
  var cards = [
    //{ left: 20, top: 15 },
    { left: 70, top: 21 },
    { left: 35, top: 16 },
    { left: 55, top: 17 },
    { left: 27, top: 35 },
    { left: 42, top: 30 },
    //{ left: 84, top: 34 },
    { left: 50, top: 39 },
    // { left: 66, top: 30 },
    { left: 73, top: 40 },
    // { left: 15, top: 48 },
    { left: 34, top: 46 },
    { left: 58, top: 45 },
    //{ left: 79, top: 47 },
  ];

  onMount(() => {
    ready = true;
  });
</script>

<style type="text/scss">.card-container {
  position: relative; }
</style>

<div class="card-container" bind:offsetHeight={height} bind:offsetWidth={width}>
  {#if ready}
    {#each cards as c, i}
      <div
        in:fade={{ delay: 300 * i, duration: 400 }}
        class="card {i < cards.length - 2 ? 'showImg' : ''}"
        style="top: {c.top * multiplier}%; left: {c.left}%; ">
        <div
          class="card-inside"
          style="background-image: {i < cards.length - 2 ? 'url(./img/5g' + i + '.png)' : ''};" />

      </div>
    {/each}
  {/if}
</div>
